import service from './api.services';

const buscarEtapaPRADA = async (idProcesso) => {
    const response = await service.get(`/api/etapa-prada/${idProcesso}`);
    return response.data;
};

const salvar = async (idProcesso, etapaPRADA) => {
    const response = await service.post(`/api/etapa-prada/${idProcesso}`, etapaPRADA);
    return response.data;
};

const buscarImagensArea = async (listaInfoImagens) => {
    const response = await service.post('/api/etapa-prada/imagem-area', listaInfoImagens);
    return response.data;
};

const downloadProcuracao = async (urlProcuracao) => {
    const response = await service.post('/api/etapa-prada/download-procuracao', urlProcuracao, {
        responseType: 'blob'
    });
    return response;
};

export {
    buscarEtapaPRADA,
    salvar,
    buscarImagensArea,
    downloadProcuracao
};
